type LogLevel = 'debug' | 'info' | 'warn' | 'error';

interface LogEntry {
  level: LogLevel;
  message: string;
  timestamp: string;
  data?: any;
}

class Logger {
  private static instance: Logger;
  
  private constructor() {}

  static getInstance(): Logger {
    if (!Logger.instance) {
      Logger.instance = new Logger();
    }
    return Logger.instance;
  }

  private log(level: LogLevel, message: string, data?: any): LogEntry {
    const entry: LogEntry = {
      level,
      message,
      timestamp: new Date().toISOString(),
      data
    };

    if (import.meta.env.DEV) {
      const color = {
        debug: '#808080',
        info: '#0066cc',
        warn: '#ff9900',
        error: '#cc0000'
      }[level];

      console.log(
        `%c[${level.toUpperCase()}]%c ${message}`,
        `color: ${color}; font-weight: bold`,
        'color: inherit',
        data || ''
      );
    }

    return entry;
  }

  debug(message: string, data?: any): LogEntry {
    return this.log('debug', message, data);
  }

  info(message: string, data?: any): LogEntry {
    return this.log('info', message, data);
  }

  warn(message: string, data?: any): LogEntry {
    return this.log('warn', message, data);
  }

  error(message: string, data?: any): LogEntry {
    return this.log('error', message, data);
  }
}

export const logger = Logger.getInstance();